import { useQuery } from '@tanstack/react-query';
import { getAudits } from 'api/audits';
import { auditsKeys } from 'api/queryKeys';
import { useMainCompanyQuery } from './useMainCompanyQuery';

export const useAuditsQuery = (
  filters: { area_ids?: number[] },
  page?: number,
  perPage?: number,
  options?: { enabled?: boolean }
) => {
  const { data: mainCompany } = useMainCompanyQuery();
  const companyId = mainCompany?.id ?? '';

  return useQuery({
    queryKey: auditsKeys.list(companyId, filters, page, perPage),
    queryFn: () =>
      getAudits({
        filters: {
          ...filters,
          page,
          per_page: perPage
        }
      }).then((res) => ({ data: res.data ?? [], pagination: res.pagination })),
    enabled: !!companyId && (options?.enabled ?? true)
  });
};
